import { useRef, useState } from "react";
import { toast } from "sonner";
import { Camera, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PhotographerAvatar } from "@/components/PhotographerAvatar";

const MAX_MB = 5;

export const AvatarUploader = () => {
  const { user, setUser } = useAuth();
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const run = async (fn, msg) => {
    setBusy(true);
    try {
      const { data } = await fn();
      setUser({ ...user, avatar_version: data.avatar_version });
      toast.success(msg);
    } catch (e) {
      toast.error(formatErr(e));
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  const upload = (file) => {
    if (!file) return;
    if (file.size > MAX_MB * 1024 * 1024) return toast.error(`Ukuran foto maksimal ${MAX_MB}MB`);
    const fd = new FormData();
    fd.append("file", file);
    run(() => api.post("/photographer/avatar", fd), "Foto profil diperbarui");
  };

  return (
    <section className="rounded-2xl bg-white border border-zinc-200 p-8 mb-6 flex flex-col sm:flex-row sm:items-center gap-5" data-testid="avatar-uploader">
      <PhotographerAvatar id={user.id} name={user.name} version={user.avatar_version} size="h-24 w-24 text-3xl" testId="avatar-preview" />
      <div className="flex-1 space-y-3">
        <div>
          <p className="font-semibold">Foto profil</p>
          <p className="text-sm text-zinc-500">JPG, PNG, atau WEBP maks. {MAX_MB}MB. Foto otomatis dipotong persegi dan tampil di profil publik serta daftar fotografer.</p>
        </div>
        <div className="flex flex-wrap gap-2">
          <Button type="button" disabled={busy} onClick={() => ref.current.click()} className="rounded-xl bg-blue-600 hover:bg-blue-700" data-testid="avatar-upload-button">
            <Camera className="mr-2 h-4 w-4" />{busy ? "Memproses..." : user.avatar_version ? "Ganti foto" : "Unggah foto"}
          </Button>
          {user.avatar_version && (
            <Button type="button" variant="outline" disabled={busy} onClick={() => run(() => api.delete("/photographer/avatar"), "Foto profil dihapus, kembali memakai inisial")} className="rounded-xl" data-testid="avatar-delete-button">
              <Trash2 className="mr-2 h-4 w-4" />Hapus
            </Button>
          )}
        </div>
        <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={(e) => upload(e.target.files[0])} data-testid="avatar-file-input" />
      </div>
    </section>
  );
};
